<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            药品列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit"  @click="toggleModalEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入药品名称" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
                        <el-select v-model="warehouseDrugCode" placeholder="请选择仓库" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in warehouseDrugCodeValue"
                                    :key="item.warehouseDrugCode"
                                    :label="item.name"
                                    :value="item.warehouseDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="supplierDrugCode" placeholder="请选择供应商" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in SupplierDrugCodeValue"
                                    :key="item.supplierDrugCode"
                                    :label="item.name"
                                    :value="item.supplierDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="waresTypeDrugCode" placeholder="请选择药品类型" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in WaresTypeDrugCodeValue"
                                    :key="item.waresTypeDrugCode"
                                    :label="item.name"
                                    :value="item.waresTypeDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="status" placeholder="选择药品状态" style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in status2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click='rowClick' :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="药品名称"></el-table-column>

                        <el-table-column prop="price" label="药品单价（元）"></el-table-column>

                        <el-table-column prop="supplierDrugName" label="供应商"></el-table-column>

                        <el-table-column prop="waresTypeDrugName" label="药品类型"></el-table-column>

                        <el-table-column prop="stock" label="库存"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>


                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd"  v-bind:SupplierDrugCodeValue="SupplierDrugCodeValue"  v-bind:WaresTypeDrugCodeValue="WaresTypeDrugCodeValue"  v-bind:warehouseDrugCodeValue="warehouseDrugCodeValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:SupplierDrugCodeValue="SupplierDrugCodeValue"  v-bind:WaresTypeDrugCodeValue="WaresTypeDrugCodeValue"  v-bind:warehouseDrugCodeValue="warehouseDrugCodeValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                disabledAdd:true,
                menuButtonList:null,
                disabledEdit:true,
                row:null,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                status:-1,
                totalItems: 0,
                name:'',
                pageSize:20,
                currentPage:1,
                supplierDrugCode:'',
                waresTypeDrugCode:'',
                warehouseDrugCode:'',
                th:0,
                SupplierDrugCodeValue:[],
                WaresTypeDrugCodeValue:[],
                warehouseDrugCodeValue:[],
                status2: [{
                    value: -1,
                    label: '所有状态'
                },{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '禁用'
                }],
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WarehouseDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.warehouseDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"SupplierDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.SupplierDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaresTypeDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.WaresTypeDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                var supplierDrugCode=this.supplierDrugCode;
                var waresTypeDrugCode=this.waresTypeDrugCode;
                var warehouseDrugCode=this.warehouseDrugCode;
                if(!supplierDrugCode){
                    supplierDrugCode='00000000-0000-0000-0000-000000000000'
                }
                if(!waresTypeDrugCode){
                    waresTypeDrugCode='00000000-0000-0000-0000-000000000000'
                }
                if(!warehouseDrugCode){
                    warehouseDrugCode='00000000-0000-0000-0000-000000000000'
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaresDrug/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        waresTypeDrugCode:waresTypeDrugCode,
                        supplierDrugCode:supplierDrugCode,
                        warehouseDrugCode:warehouseDrugCode,
                        name:this.name,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;   
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
             roomTypeTitle(row){
                if(row.roomType == 1){
                    return "单人间";
                }
                if(row.roomType == 2){
                    return "双人间";
                }
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                
            },



        }
    }
</script>

<style lang='scss' scoped>


/deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }

</style>
